import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listCollection, type Row } from '../../lib/db';

export function InsightList() {
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listCollection('insights', 'createdAt').then((r) => {
      setRows(r);
      setLoading(false);
    });
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h3 className="fw-bold m-0">Insights</h3>
        <Link to="/insights/new" className="btn btn-success btn-sm">New article</Link>
      </div>
      <p className="text-muted small mb-3">Employer-facing articles (salary benchmarks, cost of hiring, labour law).</p>
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <table className="table table-hover align-middle">
          <thead><tr><th>Title</th><th>Languages</th><th>Status</th><th /></tr></thead>
          <tbody>
            {rows.map((r) => {
              const title = (r.title ?? {}) as { en?: string; bg?: string };
              const langs = (['en', 'bg'] as const).filter((l) => title[l]);
              return (
                <tr key={r.id}>
                  <td>{title.en || title.bg || '—'}</td>
                  <td className="small text-muted">{langs.join(' · ').toUpperCase()}</td>
                  <td><span className={`badge ${r.status === 'published' ? 'bg-success' : 'bg-secondary'}`}>{String(r.status ?? 'draft')}</span></td>
                  <td className="text-end"><Link to={`/insights/${r.id}`} className="btn btn-sm btn-outline-secondary">Edit</Link></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
